<div class="app-shell" [class.app-shell--collapsed]="collapsed()">
  @if (shell.mobileNavOpen()) {
    <div class="app-shell__scrim" aria-hidden="true" (click)="shell.mobileNavOpen.set(false)"></div>
  }
  <div
    class="app-shell__sidebar-slot"
    [class.app-shell__sidebar-slot--open]="shell.mobileNavOpen()"
  >
    <mtm-app-sidebar />
  </div>
  <div
    class="app-shell__main"
    [class.app-shell__main--pushed]="shell.sidePanelWidth() > 0"
    [style.--side-panel-width.px]="shell.sidePanelWidth()"
  >
    <mtm-app-header />
    <main class="app-shell__content beauty-scroll">
      <router-outlet />
    </main>
  </div>
</div>
